module.exports = __webpack_public_path__ + "img/hone-solution1.330ab75d.png";